// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 判断是否是专家接口
export const expert = params => request({
  url: '/api/users/state',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
})